import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { NG_DOC_SHIKI_THEME } from '@ng-doc/app/tokens';
import { createHighlighterCore } from 'shiki/core';
import getWasm from 'shiki/wasm';
let NgDocHighlighterService = /*#__PURE__*/(() => {
  class NgDocHighlighterService {
    constructor() {
      this.theme = inject(NG_DOC_SHIKI_THEME);
    }
    async initialize(config) {
      this.highlighter = await createHighlighterCore({
        themes: [import('shiki/themes/github-light.mjs'), import('shiki/themes/ayu-dark.mjs'), ...(config?.themes ?? [])],
        langs: [import('shiki/langs/angular-html.mjs')],
        loadWasm: getWasm
      });
    }
    highlight(code) {
      return this.highlighter.codeToHtml(code, {
        lang: 'angular-html',
        themes: {
          light: this.theme.light || 'github-light',
          dark: this.theme.dark || 'ayu-dark'
        }
      });
    }
    static {
      this.ɵfac = function NgDocHighlighterService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocHighlighterService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgDocHighlighterService,
        factory: NgDocHighlighterService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgDocHighlighterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocHighlighterService };
